import React from "react"
import { localized, localizedF } from "js/includes/common/utils"
import { Col, ControlLabel, FormGroup, HelpBlock } from "react-bootstrap"
import Select from "react-select"
import { propEq } from "ramda"

const enabledOptions = [
  { value: true, label: localizedF("general.turnOn") },
  { value: false, label: localizedF("general.turnOff") },
]
export default function SystemRestore({ onChange, values: { enabled }, validation }) {
  return (
    <FormGroup
      className="m-sm m-b-lg text-align-left"
      validationState={validation.success.enabled === false ? "error" : null}
    >
      <Col xs={4} componentClass={ControlLabel}>
        {localized("editors.policy.actions.options")}
      </Col>
      <Col xs={8}>
        <Select
          {...{
            getOptionLabel: ({ label }) => label(),
            id: "systemRestoreOptions",
            options: enabledOptions,
            value: enabledOptions.find(propEq("value", enabled)),
            onChange: selection => onChange("enabled", selection.value),
          }}
        />
        <HelpBlock className="invalid position-absolute m-t-none">
          {validation.success.enabled === false && validation.message.enabled}
        </HelpBlock>
      </Col>
    </FormGroup>
  )
}
